// import svgColorError from '@ui/lib/helpers/svgColorError'
import clsx from 'clsx'

export type BaseSVGProps = {
  className?: string
  color?: string
  height?: number | string
  width?: number | string
  viewBox?: string
} & React.SVGProps<SVGSVGElement>

export const STROKE_WIDTH = {
  BASE: '1.44286',
  THICK: '1.42857',
}

const BaseIcon = ({
  className,
  height,
  width,
  color,
  strokeWidth,
  children,
  viewBox,
  ...rest
}: React.PropsWithChildren<BaseSVGProps>) => {
  // svgColorError(color)

  // Pass the stroke prop to the svg element
  // TBD: This is not working as expected
  // const svgProps = {
  //   strokeWidth: stroke === 'thick' ? '2' : '1.5',
  //   strokeLinecap: 'round',
  //   strokeLinejoin: 'round',
  // }

  // const updatedChildren = React.Children.toArray(children)
  // updatedChildren[0] = { ...(updatedChildren[0] as React.ReactElement), ...svgProps }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? '24'}
      height={height ?? '24'}
      viewBox={viewBox ?? '0 0 24 24'}
      className={clsx(color, className)}
      strokeWidth={strokeWidth ?? STROKE_WIDTH.BASE}
      {...rest}>
      {children}
    </svg>
  )
}

export default BaseIcon
